import { Badge, Stack, Text } from '@mantine/core';

import { LABELS } from '../../../constants';

type KeywordsListProps = {
  keywords: Record<string, number>;
};

export const KeywordsList = ({ keywords }: KeywordsListProps) => {
  if (!keywords || Object.keys(keywords).length === 0) {
    return <Text>{LABELS.EMPTY_CELL}</Text>;
  }

  return (
    <Stack>
      {Object.entries(keywords).map(([keyword, count]) => (
        <Badge key={keyword} variant="light" color="violet" radius="sm">
          {keyword}: {count}
        </Badge>
      ))}
    </Stack>
  );
};
